import "./Home.scss";

import React from "react";
import { useTranslation } from "react-i18next";

import Contact from "../../components/Contact/Contact";
import Separator from "../../components/Separator/Separator";
import useWindowWidth from "../../hooks/useWindowWidth";
import About from "./About/About";
import Gallery from "./Gallery/Gallery";
import Hero from "./Hero/Hero";
import Services from "./Services/Services";
import Values from "./Values/Values";

const Home: React.FC = () => {
  const { isTabelet } = useWindowWidth();
  const { t } = useTranslation();

  return (
    <div className="home">
      <Hero />
      <About />
      <Separator />
      <Values />
      <Separator />
      <Services />
      <Separator />
      <Gallery />
      <Separator />
      <Contact />
    </div>
  );
};

export default Home;
